import { simpleSet } from '@r/reducers/utils';

export const fixLabourCost = simpleSet(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_FIX_LABOUR_COST',
  0
);
